class PolicyService {
    constructor() {
    }

    getPolicyRule(policy, amount) {
        // Get first applicable rule
        let rule;
        for (let i = policy.rules.length - 1; i >= 0; i--) {
            if (policy.rules[i].minApplyAmountInclude) {
                if (policy.rules[i].minApplyAmount <= amount) {
                    rule = policy.rules[i];
                    break;
                }
            } else {
                if (policy.rules[i].minApplyAmount < amount) {
                    rule = policy.rules[i];
                    break;
                }
            }
        }

        return rule;
    }
}

module.exports = new PolicyService();